<template>
  <div class="section">
    <div class="box">
      <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
      <table class="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>Title</th>
            <th>Label</th>
            <th>Select</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data_row, index) in data_list" :key="index">
            <td>{{ data_row.title }}</td>
            <td>{{ data_row.label }}</td>
            <td>
              <button v-if="data_row.selected === 0" type="button" :class="{'button is-link': true}" @click="selectMenu(data_row.id, 1)">Select</button>
              <button v-else type="button" :class="{'button is-warning': true}" @click="selectMenu(data_row.id, 0)">Selected</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list_breadcrumbs: [],
      division_id: '',
      campus_coordinator_id: '',
      data_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.campus_coordinator_id = this.$route.params.id
    this.division_id = this.$route.params.parent_id
    this.list_breadcrumbs = [
      {
        title: 'Division',
        path: '/panel/division/'
      },
      {
        title: 'Campus Coordinator',
        path: '/panel/division/campus_coordinator/' + this.division_id
      },
      {
        title: 'Menu',
        path: '/panel/division/campus_coordinator/menu/' + this.division_id + '/' + this.campus_coordinator_id
      }
    ]
    this.getMenuList()
  },
  methods: {
    getMenuList () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/menu/get_menu_campus_coordinator', {
        campus_coordinator_id: this.campus_coordinator_id
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    selectMenu (menuId, flag) {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/menu/select_menu_campus_coordinator', {
        campus_coordinator_id: this.campus_coordinator_id,
        menu_id: menuId,
        flag: flag
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/division/campus_coordinator/Menu.vue